import React, {useState, useEffect} from 'react';

import ArtistAvatar from '../../artist-avatar/artist-avatar';
import {get, urlencoded} from '../../../services/artfinder-service';
import {emit} from '../../../utils/events';
import useAuth from '../../../hooks/use-auth/use-auth';
import _ from '../../../utils/_';
import Location from '../../icons-af/location';
import Rating from '../../rating/rating';
import Button from '../../button/button';
import CardRibbon from '../../card-ribbon/card-ribbon';
import {P} from '../../typography/typography';
import {followArtistEvent} from '../../../utils/gtm';
import './artist-card.scss';

const ArtistCard = ({artist}) => {
  const [following, setFollowing] = useState(false);
  const [loading, setLoading] = useState(false);
  const auth = useAuth();

  const getAndSetFollowing = () => {
    get('/interest/follows.js')
      .then(_.pipe(_.includes(artist.slug), setFollowing))
      .catch((err) => {
        console.log('follows api error', err);
      });
  };

  const toggleFollow = () => {
    if (!auth.isAuthenticated()) {
      emit('CLICK_ON_LOGIN');
      return;
    }
    setLoading(true);
    urlencoded('/interest/', {
      object_type: 'artists.Artist',
      object_id: artist.id,
      interested: !following,
    })
      .then(() => {
        getAndSetFollowing();
        followArtistEvent(artist);
      })
      .catch((err) => {
        console.log('artist follow error', err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const countFilter = (count) => {
    if (count < 1000) {
      return count;
    } else if (count % 1000 === 0) {
      return `${count / 1000}K`;
    } else {
      return `${Math.floor(count / 100) / 10}K+`;
    }
  };

  useEffect(getAndSetFollowing, []);

  return (
    <div className="artist-card">
      <div className="wrapper">
        <div className="img-grid">
          {artist.products.length > 0 && (
            <div>
              <img loading="lazy" src={artist.products[0].retina_url}></img>
            </div>
          )}

          {artist.products.length > 1 && (
            <div>
              <div>
                <img loading="lazy" src={artist.products[1].retina_url}></img>
              </div>

              {artist.products.length > 2 && (
                <div>
                  <img loading="lazy" src={artist.products[2].retina_url}></img>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {artist.sale_discount_amount && <CardRibbon label={`${artist.sale_discount_amount}% sale`} />}

      <a href={artist.url} />

      <ArtistAvatar alt={artist.name} src={artist.avatar_url} />

      <P style="p1-b">{artist.name}</P>

      <P style="p2">
        <Location />
        {artist.country}
      </P>

      <P style="p3">
        {artist.seller_rating && (
          <>
            <Rating value={artist.seller_rating} size="10px" />
            &nbsp;({countFilter(artist.review_count)})
          </>
        )}
      </P>

      <Button active={following} disabled={loading} onClick={toggleFollow} icon="heart"></Button>
    </div>
  );
};

export default ArtistCard;
